import $ from "jquery";

export default class Form {
    constructor() {
        const job = new URLSearchParams(window.location.search).get('job');
        if (job) {
            const input = document.querySelector('input[name="job"]');
            input.value = job;
        }

        $('form').on('submit', this.handleSubmit);
    }

    handleSubmit(e) {
        $('body').addClass('loading');
    }
}
